export default __webpack_public_path__ + "static/7427-b3cfb34dbaf81ba45f9d857638d534fc.jpg";